import './bootstrap_alpine';

window.Alpine = require('alpinejs');
// Lazy-Load
window.lozad = require('lozad');

const observer = lozad();
observer.observe();

// Progress Bar
window.ProgressBar = require('progressbar.js')

// Slick
import Slick from 'slick-carousel';

/* Interstitials - Start */
var interstitials = null;
var count = 0;
var animation = null;
var vrm = '';

window.addEventListener('load', function () {
    let interstitial = $('#interstitialModal').remove();
    interstitial.attr('id', 'interstitialId');
    $(document.body).append(interstitial);

    let vrmInputErrorModal = $('#vrmInputErrorModal').remove();
    vrmInputErrorModal.attr('id', 'vrmInputErrorId');
    $(document.body).append(vrmInputErrorModal);

    let reportExistsModal = $('#reportExistsModal').remove();
    reportExistsModal.attr('id', 'reportExistsId');
    $(document.body).append(reportExistsModal);
});

function getInterstitials(vrm, type) {
    return [
        {
            icon: 'icon-mot-tax-check',
            text: 'Please Wait - We are firing up our engines...',
        },
        {
            icon: 'icon-detailed-mileage-check',
            text: 'Checking DVLA and MOT data from Government databases...',
        },
        {
            icon: 'icon-detailed-mileage-check',
            text: 'Checking over 300m readings in the Mileage database...',
        },
        {
            icon: 'icon-finance-check',
            text: 'Checking MIAFTR Insurance Write-Off database...',
        },
        {
            icon: 'icon-finance-check',
            text: 'Checking Finance database...',
        },
        {
            icon: 'icon-stolen',
            text: 'Checking Police Stolen database...',
        },
        {
            icon: 'icon-tick',
            text: 'Your MotorCheck report is ready!',
        },
    ];
}

function loadInterstitial() {
    count++;
    $('#interstitialId #insterstitialImg').attr("src", "/images/" + interstitials[count].icon + ".svg");
    $('#interstitialId #insterstitialText').text(interstitials[count].text);

    if (count >= (interstitials.length - 1)) {
        clearInterval(animation);
        $('#interstitialId #insterstitialWait-1').hide();
        $('#interstitialId #insterstitialWait-2').hide();

        window.livewire.emit('endInterstitials');
    }
}

window.addEventListener('run-interstitials', event => {
    $('#reportExistsId').modal('hide');
    vrm = event.detail.vrm;
    count = 0;
    interstitials = getInterstitials(event.detail.vrm, event.detail.product);

    $('#interstitialId').modal({ backdrop: 'static', keyboard: false });
    $('#interstitialId #insterstitialImg').attr("src", "/images/" + interstitials[count].icon + ".svg");
    $('#interstitialId #insterstitialText').text(interstitials[count].text);
    $('#interstitialId #insterstitialWait-1').show();
    $('#interstitialId #insterstitialWait-2').show();

    animation = setInterval(loadInterstitial, 667);
})

window.addEventListener('existing-report', event => {
    $('#reportExistsId .report-exists-text')
        .text("A report has already been created in your account for " + vrm);
    $('#interstitialId').modal('hide');
    $('#reportExistsId').modal('show');
})

window.addEventListener('vrm-error', event => {
    $('#interstitialId').modal('hide');
    $('#vrmInputErrorId').modal('show');
})
/* Interstitials - End */

window.addEventListener('check-lozad', event => {
    const observerDynamic = lozad();
    observerDynamic.observe();
})
